import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Table } from 'antd';
import { Content, PageSectionHeader } from '@/components';
import { NAMESPACE } from '@/constants';
import { UserForm } from './components';
import { useUserSettings } from './hooks/useUserSettings';

const renderTotalItemsCount = (total: number) => `Total ${total} items`;

const UserSettings: FC = () => {
  const {
    closeUserForm,
    columns,
    handleOpenUserForm,
    handlePaginationChange,
    isFetching,
    isUserFormOpen,
    user,
    userList,
    count,
    limit,
    page
  } = useUserSettings();
  const { t } = useTranslation(NAMESPACE.USER_SETTINGS_PAGE);

  return (
    <>
      <PageSectionHeader
        actions={
          <Button onClick={() => handleOpenUserForm()} size="large" type="primary">
            {t('createUser')}
          </Button>
        }
      >
        {t('userSettings')}
      </PageSectionHeader>
      <Content>
        <UserForm user={user} isOpen={isUserFormOpen} close={closeUserForm} />
        <Table
          loading={isFetching}
          dataSource={userList}
          columns={columns}
          pagination={{
            disabled: isFetching,
            showQuickJumper: true,
            totalBoundaryShowSizeChanger: 10,
            showTotal: renderTotalItemsCount,
            defaultPageSize: limit,
            total: count,
            onChange: handlePaginationChange,
            current: page
          }}
        />
      </Content>
    </>
  );
};

export default UserSettings;
